export const conditionalPopupCategories = {
  SubscribePopup: ['Productivity tips', 'Remote work tips', 'App tutorials'],
  SignupPopup: [
    'Automation inspiration',
    'Best apps',
    'Small business tips',
    'App comparisons',
    'App tips',
    'How we work at Zapier',
    'App of the day',
    'Zapier tutorials',
    'Customer stories',
  ],
};
